export const selectRegionsById = state =>
  state.RegionsReducer.regions.map(region => region.id);

export const selectRegions = state =>
  state.RegionsReducer.regions.reduce((ac, region) => {
    ac[region.id] = { ...region };
    return ac;
  }, {});

export const selectCountriesById = state =>
  state.RegionsReducer.countries.map(country => country.id);

export const selectCountries = state =>
  state.RegionsReducer.countries.reduce((ac, country) => {
    ac[country.id] = { ...country };
    return ac;
  }, {});

export const selectHoursConverted = hours => {
  let hoursObject = {};
  const isValidHours = str =>
    /^(\\([0-9]{2}\\))?[0-2]{1}[0-9]{1}:[0,3]{2}$/.test(str);
  const isValidYN = string => /^[YN]{1}$/.test(string);
  for (let [key, value] of Object.entries<string>(hours)) {
    value = typeof value === 'string' ? value.substring(0, 5) : value;

    if ((key.includes('Time'))) {
      if (value === '' || value === null) {
        hoursObject[key] = null;
      }
      else if (isValidHours(value)) {
        hoursObject[key] = value;
      }
    }

    if (isValidYN(value)) {
      hoursObject[key] = value;
    }
  }
  return hoursObject;
};
